import { useMemo } from 'react';
import { getCardsRatingSum } from '../utils';
import { useCollectionProgress } from '../collectionProgress';
import { isEmptyObject } from '../../../utils/records';
var useCollectionGoals = function (collectionId) {
    var progress = useCollectionProgress(collectionId);
    return useMemo(function () {
        var _a, _b, _c;
        var collection = progress === null || progress === void 0 ? void 0 : progress.collection;
        if (!collection) {
            return null;
        }
        var goals = collection.goals;
        var reachTargetValue = goals.reachTargetValue
            ? {
                isRequired: true,
                isFulfilled: getCardsRatingSum(progress) >= goals.targetValue,
                targetValue: goals.targetValue,
                targetValueMax: goals.targetValueMax,
            }
            : { isRequired: false };
        var fillRequired = goals.fillRequired
            ? {
                isRequired: true,
                isFulfilled: collection.slots.every(function (slot, i) {
                    var _a;
                    var isSpecialSlot = !isEmptyObject(slot) && slot.specialGroup;
                    var insertedSlot = (_a = progress === null || progress === void 0 ? void 0 : progress.progress) === null || _a === void 0 ? void 0 : _a.slots[i];
                    var hasInsertedCard = insertedSlot && !isEmptyObject(insertedSlot) && insertedSlot.card;
                    return !isSpecialSlot || hasInsertedCard;
                }),
            }
            : { isRequired: false };
        var fillAll = goals.fillAll
            ? {
                isRequired: true,
                isFulfilled: (_c = (_b = (_a = progress === null || progress === void 0 ? void 0 : progress.progress) === null || _a === void 0 ? void 0 : _a.slots) === null || _b === void 0 ? void 0 : _b.every(function (slot) { return isEmptyObject(slot) || (slot === null || slot === void 0 ? void 0 : slot.card); })) !== null && _c !== void 0 ? _c : false,
            }
            : { isRequired: false };
        return {
            reachTargetValue: reachTargetValue,
            fillAll: fillAll,
            fillRequired: fillRequired,
        };
    }, [progress]);
};
export default useCollectionGoals;
